export default __webpack_public_path__ + "static/media/(51).b2b0dea5.jpg";